// Uebergangs-Gate der Free-Automatik im FRONTEND (Preisumbau Baender).
//
// Client-Pendant zu `supabase/functions/_shared/free-automation-gate.ts`
// (`isFreeAutomationGateActive`) — GLEICHE Semantik, andere Env-Quelle:
// der Server liest FREE_AUTOMATION_GATE_AT, die App liest
// VITE_FREE_AUTOMATION_GATE_AT (import.meta.env). Bis Dennis beide Werte
// setzt, koennen Server und Client auseinanderliegen — dokumentiertes
// Rest-Risiko des Rollouts; der Server ist das harte Gate, die App nur die
// ehrliche Anzeige.
//
//   unset / leer / nur Whitespace / unparsebar → Gate INAKTIV (heutiges
//   Verhalten fuer alle, auch Free)
//   gesetzt und now >= Stichtag               → Free-Konten verlieren die
//   Automatik-Toggles (Schedules.tsx sperrt Switches + Checkboxen)

/**
 * Duenner Env-Reader — liest bei jedem Aufruf, damit die pure Funktion darunter
 * in Tests mit explizitem envValue laufen kann. Unter vitest ist der Wert
 * regulaer undefined → Gate inaktiv.
 */
export function readFreeAutomationGateEnv(): string | undefined {
  const value = import.meta.env?.VITE_FREE_AUTOMATION_GATE_AT;
  return typeof value === 'string' ? value : undefined;
}

/**
 * Ist das Uebergangs-Gate aktiv? Pure bei explizitem envValue/now — die
 * Default-Parameter sind nur die Verdrahtung fuer den Produktionspfad.
 * Unset, leer, nur Whitespace oder unparsebar → false (Gate inaktiv).
 * Der exakte Stichtag zaehlt als erreicht (now >= gate), wie serverseitig.
 */
export function isFreeAutomationGateActive(
  envValue: string | null | undefined = readFreeAutomationGateEnv(),
  now: Date = new Date(),
): boolean {
  if (typeof envValue !== 'string') return false;
  const trimmed = envValue.trim();
  if (trimmed === '') return false;
  const gateMs = Date.parse(trimmed);
  if (!Number.isFinite(gateMs)) return false;
  return now.getTime() >= gateMs;
}
